import { defaultColumns, defaultSort } from '../../components/processes/stockTakings/stockTakingTools/columns';

export default {
  state: {
    stockTakingTools: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'asc',
    },
  },
  getters: {
    stockTakingTools: state => state.stockTakingTools,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setStockTakingTools(state, stockTakingTools) {
      state.stockTakingTools = stockTakingTools;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/stock-taking-tools-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'stock-taking-tools-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const stockTakingTools = await axios.get('api/stock-taking-tools' + (query || ''));
        commit('setStockTakingTools', stockTakingTools);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      return await axios.get(`api/stock-taking-tools/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/stock-taking-tools', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/stock-taking-tools', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/stock-taking-tools/${id}`);
    },
  },
};
